module.exports = function (data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="image">\r\n        <img src="' +
((__t = ( data.Image )) == null ? '' : __t) +
'">\r\n</div>\r\n<div class="details">\r\n    <h3 class="title">' +
((__t = ( data.Name )) == null ? '' : __t) +
'</h3>\r\n    <p class="description">' +
((__t = ( data.Description )) == null ? '' : __t) +
'</p>\r\n    <ul class="authors">\r\n        ';
 data.CreatedBy.forEach((creator)=>{ ;
__p += '\r\n        <li>' +
((__t = ( creator )) == null ? '' : __t) +
'</li>\r\n        ';
 }) ;
__p += '\r\n    </ul>\r\n    \r\n    <div class="votes">' +
((__t = ( data.Votes )) == null ? '' : __t) +
' VOTES</div>\r\n</div>\r\n<img class="x" src="assets/x.svg" />';
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/views/Pumpkin.ejs
// module id = 4
// module chunks = 0